import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';

import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from './components/shared/shared.module';
import { ErrorInterceptor } from './interceptors/interceptor'; // Importamos el interceptor
import { InterceptorErrorComponent } from './pages/interceptor-error/interceptor-error.component';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { MatSliderModule } from '@angular/material/slider';
import { register } from 'swiper/element/bundle';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SuccessBannerComponent } from './components/success-banner/success-banner.component';
import { TokenInterceptor } from './interceptors/token_interceptor';
import { UserPrivatedModule } from './pages/user-privated/user-privated.module';
import { MatIconModule } from '@angular/material/icon';
import { RecoverPassComponent } from './pages/user_public/recover-pass/recover-pass.component';
import { TestSelectorComponent } from './pages/test-selector/test-selector.component';
//import { AboutComponent } from './pages/user_public/about/about.component';
register();

@NgModule({
  declarations: [
    AppComponent,
    InterceptorErrorComponent,
    SuccessBannerComponent,
    RecoverPassComponent,
    TestSelectorComponent
    //  AboutComponent,
  ],
  imports: [
    BrowserModule,
    FontAwesomeModule,
    MatSliderModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    RxReactiveFormsModule,
    SharedModule,
    NoopAnimationsModule,
    UserPrivatedModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
